import React from "react";

const Error404 = () => {
    
    return (
        <div className="container">
        <div className="copy-container center-xy">
            <p className="font-monospace">
            404, page not found.
            </p>
            <span className="handle"></span>

        </div>
        </div>        
        
    )
}

export default Error404;